module.exports = __webpack_public_path__ + "static/media/advisor-introduction-anssi-pakkanen.66d9447c.jpg";